import { query_kzk_card_record_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
} from '@/components/page-model/mjstore/mjstore-orderrecordcard-config';

import { reactive } from 'vue';
import { get_is_delete, toFixed0 } from '@/utils/function';

export default () => {
  const None = null;
  const True = true;
  const False = false;

  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'remotemodal',
        name: 'customer_id',
        label: '会员姓名',
        disabled: false,
        placeholder: '请选择会员姓名',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-customer',
      },
      {
        type: 'remoteselect',
        name: 'staff_id',
        label: '执行人',
        disabled: false,
        placeholder: '请选择执行人',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-staff',
      },
      {
        type: 'rangepicker',
        name: 'date_interval',
        label: '卡转卡日期',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        format: 'YYYY-MM-DD',
        valueFormat: 'YYYY-MM-DD',
        showTime: false,
        placeholder: '请选择卡转卡日期',
      },
      {
        type: 'input',
        name: 'card_code',
        label: '卡号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写卡号',
      },
      {
        type: 'input',
        name: 'card_name',
        label: '卡名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写卡名称',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      order_code: null,
      project_id: null,
      customer_id: null,
      staff_id: null,
      card_id: null,
      card_record_id: null,
      cxzc_id: null,
      shop_id: current_shop?.id,
      date: null,
      is_cancel: false,
      delete_staff_id: null,
    }),
  };
  const search_options = {
    is_delete: [
      { value: None, name: '全部' },
      { value: True, name: '已作废' },
      { value: False, name: '未作废' },
    ],
  };

  const edit_model_config = {};
  const edit_model_config_options = {};

  const update_model_config = {};
  const update_model_config_options = {};

  const titleList = {
    title: '卡转卡',
    addModalTitle: '新建卡转卡记录',
    updateTitle: '修改卡转卡记录',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
      slots: { customRender: 'index' },
    },
    {
      title: '卡转卡编号',
      width: 180,
      dataIndex: 'kzk_code',
      checked: true,
    },
    {
      title: '新卡号/原卡号',
      width: 180,
      dataIndex: '_order_code',
      checked: true,
    },
    {
      title: '诉求号',
      width: 170,
      dataIndex: 'require_info__code',
      checked: true,
    },
    {
      title: '会籍门店',
      width: 140,
      dataIndex: 'customer__shop__name',
      checked: true,
    },
    {
      title: '会员编号',
      width: 140,
      dataIndex: 'customer__code',
      checked: true,
    },
    {
      title: '会员姓名',
      width: 150,
      dataIndex: 'customer__name',
      checked: true,
    },
    {
      title: '卡名称',
      width: 180,
      dataIndex: '_card_name',
      checked: true,
    },
    {
      title: '新卡次数/扣卡次数',
      width: 150,
      dataIndex: '_card_num',
      checked: true,
    },
    {
      title: '单价',
      width: 80,
      dataIndex: '_card_single_price',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '卡金额',
      width: 80,
      dataIndex: '_card_price',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '充值使用金额',
      width: 110,
      dataIndex: 'czje',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '返利使用金额',
      width: 110,
      dataIndex: 'flje',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '直接返利',
      width: 110,
      dataIndex: 'zjfl',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '赠券使用金额',
      width: 110,
      dataIndex: 'zjje',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '促销政策',
      width: 110,
      dataIndex: 'diff_price',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '备注',
      width: 110,
      dataIndex: 'mark',
      checked: true,
    },
    {
      title: '所属顾问',
      width: 150,
      dataIndex: 'customer__adviser__name',
      checked: true,
    },
    {
      title: '执行门店',
      width: 110,
      dataIndex: 'shop__name',
      checked: true,
    },
    {
      title: '执行人',
      width: 75,
      dataIndex: 'staff__name',
      checked: true,
    },
    {
      title: '单据状态',
      width: 110,
      dataIndex: 'is_delete',
      checked: true,
      cellComponent: 'boolean',
      name1: '已作废',
      name2: '未作废',
      color1: 'red',
      color2: 'green',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '已作废', value: true },
        { text: '未作废', value: false },
      ],
      content: (record: any, text: any) => {
        return get_is_delete(text);
      },
    },
    {
      title: '卡转卡日期',
      width: 150,
      dataIndex: 'date',
      fixed: false,
      checked: true,
    },
    {
      title: '创建日期',
      width: 150,
      dataIndex: 'create_time',
      fixed: false,
      checked: true,
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push({
    type: 'custom',
    slotName: 'is_delete',
    field_true: '已作废',
    field_false: '未作废',
  });

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_kzk_card_record_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
    rowKey: '_index',
    customRow: (record: any, index: any) => {
      return {
        onmouseenter: (event: any) => {
          event.currentTarget.parentElement.childNodes.forEach((item: any) => {
            if (item.textContent && item.textContent.indexOf(record.kzk_code) > -1) {
              item.style.background = '#D8E6DF';
            }
            event.currentTarget.style.background = '#D8E6DF';
          });
        },
        onmouseleave: (event: any) => {
          event.currentTarget.parentElement.childNodes.forEach((item: any) => {
            if (item.textContent && item.textContent.indexOf(record.kzk_code) > -1) {
              item.style.background = '';
            }
          });
          event.currentTarget.style.background = '';
        },
      };
    },
  };
};
